module.exports = __webpack_public_path__ + "static/media/home-about-img1.1e9ea1f4.svg";